import { ApolloError } from "@apollo/client";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { MdmObjectJobDto, AnalyticsResultDto, MdmDeviceDto } from "gql/generated/types";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";
import { priorityType } from "./const";
import DeviceStatusTag from "../components/DeviceStatus";

  export const getFormErrorMessage = (name: keyof FieldValues, errors: FieldErrors<FieldValues>) => {
    return errors[name] ? <small className="p-error">{errors[name]?.message as string}</small> : <small className="p-error">&nbsp;</small>;
  }

  export const successToaster = (msg: string) => easasAlert({
    severity: "success",
    summary: "Success",
    detail: msg,
    life: 2000,
  });

  export const errorToaster = (err: ApolloError) => {
    easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
  };

  export const severityRowFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (
      <Dropdown
        value={options.value}
        options={Object.entries(priorityType).map(([key, value]) => ({ label: value.value, value: key }))}
        onChange={e => options.filterApplyCallback(e.value)}
        placeholder="Select One"
        showClear
      />
    );
  };
  
  export const renderSeverity = (rowData: MdmObjectJobDto | AnalyticsResultDto) => (
    <i
      className={priorityType[rowData.severity!].icon}
      style={{ color: priorityType[rowData.severity!].severity }}
      title={priorityType[rowData.severity!].value}
    ><span className="pl-2 text-gray-900">{priorityType[rowData.severity!].value}</span></i>
  );

  export const handleDeviceStatus = (rowData?: MdmDeviceDto | null) => (
    <DeviceStatusTag
      status={rowData?.status.status}
      lastMeasurementDate={rowData?.status.lastMeasurementDate}
    />
  );